<template>
  <div v-if="dataProvided" class="auction_house-modal-banner d-flex flex-column flex-md-row justify-content-between">
    <div class="auction_house-modal-banner__name">
      <p class="auction_house-modal-banner__name--short-name">
        <strong>
          {{ auctionsCatalog.auctionHouseShortName }}
        </strong>
      </p>
      <p class="auction_house-modal-banner__name--name">
        <strong>
          {{ auctionsCatalog.name }}
        </strong>
      </p>
    </div>
    <div class="auction_house-modal-banner__date d-flex flex-column align-items-start align-items-md-end">
      <p>
        <span>{{ I18n.l("time.formats.full_date", auctionsCatalog.startDate) }}</span>
        <span class="icon icon-calendar ml-2"></span>
      </p>
      <p>
        <span>{{ startTime }}</span>
        <span class="icon icon-time ml-2"></span>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AuctionHouseName',
    props: {
      auctionsCatalog: {
        type: Object,
        required: true,
      },
    },
    computed: {
      dataProvided() {
        const hasOwnProperty = Object.prototype.hasOwnProperty;
        return hasOwnProperty.call(this.auctionsCatalog, 'startDate') &&
               hasOwnProperty.call(this.auctionsCatalog, 'name') &&
               hasOwnProperty.call(this.auctionsCatalog, 'auctionHouseShortName');
      },
      startTime() {
        return this.auctionsCatalog.startDate.substring(11, 16);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/modal/auction_house_name.vue?145ae4f8